import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { homeFor } from "../redux/features/authSlice";

// Route guard by role. No session -> login. Wrong role -> that user's own
// home, never a blank page. Pass `roles` to restrict, omit to allow any
// signed-in user.
//
// The server enforces every permission again; this only keeps people out
// of screens that would 403 anyway.
const RequireRole = ({ roles, children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  if (!isAuthenticated || !user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to={homeFor(user)} replace />;
  return children || <Outlet />;
};

export const STAFF = ["ADMIN", "OPS"];
export const CUSTOMER = ["CUST_ADMIN", "CUST_MANAGER", "CUST_APPROVER", "CUST_ACCOUNTS"];
export const CUSTOMER_ADMIN = ["CUST_ADMIN"];

export default RequireRole;
